import { doFetch } from "./ConnectionManager";

let sessionProfile = null;
let validationPromise = null;

export function getSessionProfile() {
  return sessionProfile;
}

export function acceptSession(profile) {
  sessionProfile = profile || null;
  return sessionProfile;
}

export function clearSession() {
  sessionProfile = null;
  validationPromise = null;
}

/**
 * Restores authentication from the server-side session cookie.
 * The cookie is deliberately not treated as application state: it may be
 * HttpOnly now or in a future hardening pass.
 */
export async function restoreSession(fetcher = doFetch, { force = false } = {}) {
  if (!force && sessionProfile) return sessionProfile;
  if (!force && validationPromise) return validationPromise;

  const validation = (async () => {
    const response = await fetcher("SSO", "getMyProfile", { _silent: true });
    if (!response) throw new Error("Session validation could not reach the server");
    if (response.status === 401 || response.status === 403) {
      sessionProfile = null;
      return null;
    }
    if (!response.ok) throw new Error(`Session validation failed with HTTP ${response.status || 0}`);

    const data = await response.json();
    if (data?.STATE !== "SUCCESS" || !data.DATA) {
      sessionProfile = null;
      return null;
    }
    sessionProfile = data.DATA;
    return sessionProfile;
  })();

  validationPromise = validation;
  try {
    return await validation;
  } finally {
    if (validationPromise === validation) validationPromise = null;
  }
}

export function resetSessionStateForTests() {
  clearSession();
}
